import { Builder } from '@builder.io/react'
import React from 'react'

interface Props {
  backgroundColor: string
  skeletonColor: string
  isHeroSkeleton: boolean
}

const SkeletonHeader = ({ backgroundColor, skeletonColor, isHeroSkeleton }: Props) => {
  return (
    <div className={`p-4 ${isHeroSkeleton ? '-mt-4 lg:-mt-12' : ''}`} style={{ backgroundColor: backgroundColor }}>
      <div
        className={`w-2/3 h-4 rounded-3xl mb-2 bg-gray-300 justify-center mx-auto mt-4 ${isHeroSkeleton ? 'lg:mt-12' : ''} animate-pulse`}
        style={{ backgroundColor: skeletonColor }}
      ></div>
    </div>
  )
}
export default SkeletonHeader

Builder.registerComponent(SkeletonHeader, {
  name: 'SkeletonHeader',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: '#f9f5f1'
    },
    {
      name: 'skeletonColor',
      type: 'color',
      defaultValue: '#e0e0e0'
    },
    {
      name: 'isHeroSkeleton',
      type: 'boolean',
      defaultValue: false
    }
  ]
})
